import { FC } from "react";
import { courseServiceFactory } from "../../../services/CourseServiceImpl";
import { useTranslation } from "react-i18next";
import { ICourse, CourseFiltersValues } from "../../../domain/models/Course";
import { CourseFiltersFields, courseFiltersSchemaFactory } from "../../../validation-schemas/CoursesSchemas";
import { GenericEntityPage } from "../../shared/GenericEntityPage";
import CoursesCard from "./CoursesCard";
import CoursesEditor from "./CoursesEditor";

const courseService = courseServiceFactory();
const CoursesPage: FC = () => {
    const { t } = useTranslation();

    return (
        <GenericEntityPage<ICourse, CourseFiltersValues>
            filtersFieldsMeta={CourseFiltersFields}
            filtersSchema={courseFiltersSchemaFactory(t)}
            service={courseService}
            renderItem={(item, onEdit, onDelete) => <CoursesCard item={item} onEdit={onEdit} onDelete={onDelete} />}
            renderEditor={({ entity, onClose, onSave, translateFields }) => (
                <CoursesEditor entity={entity} onClose={onClose} onSave={onSave} translateFields={translateFields} />
            )}
        />
    );
};

export default CoursesPage;
